import { Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'app-added-users-list',
    templateUrl: './added-users-list.component.html',
    styleUrls: ['./added-users-list.component.css']
})
export class AddedUsersListComponent {
    @Output() setOpened = new EventEmitter<boolean>();
    @Output() setDeleteModalOpened = new EventEmitter<boolean>();

    users = [
        {
            type: 'Dropped',
            name: 'xhub.com',
        },
        {
            type: 'Proxy',
            name: 'google.com',
        },
        {
            type: 'Directly',
            name: 'yandex.com',
        },
    ];
    ;

    handleOpenAddModal(): void {
        this.setOpened.emit(true);
    }

    handleEditUser(userData: {type: string, name: string}): void {
        console.error(userData.type, userData.name);
        // TODO: Implement edit functionality
    }
} 